import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faRoute, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import './GeneratingAnimation.css'; // We'll create this CSS file next

const GeneratingAnimation = () => {
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    {
      icon: faGlobe,
      text: 'Crafting your journey...',
      color: '#E57373', // Reddish
      bgColor: '#FFEBEE'
    },
    {
      icon: faRoute,
      text: 'Building the itinerary...',
      color: '#64B5F6', // Bluish
      bgColor: '#E3F2FD'
    },
    {
      icon: faFileInvoiceDollar,
      text: 'Calculating the best price...',
      color: '#81C784', // Greenish
      bgColor: '#E8F5E9'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep(prevStep => (prevStep + 1) % steps.length);
    }, 2000); // Change step every 2 seconds

    return () => clearInterval(interval); 
  }, [steps.length]); // Dependency array should be stable, but it's good practice

  return (
    <div className="generating-overlay">
      <div className="generating-icons">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`generating-icon ${index === currentStep ? 'active' : ''}`}
            style={{
              '--icon-color': step.color,
              '--bg-color': step.bgColor,
              '--shadow-color': `${step.color}66`
            }}
          >
            <FontAwesomeIcon icon={step.icon} />
          </div>
        ))}
      </div>
      <p className="generating-text">{steps[currentStep].text}</p>
      <div className="loading-ellipsis">
        <span>.</span><span>.</span><span>.</span>
      </div>
    </div>
  );
};

export default GeneratingAnimation;